import * as Yup from "yup";
import { validationErrors } from "./validationRules.js";
import validationUtils from "./ValidationUtils.js";

const createPatientSchema = Yup.object().shape({
  first_name: validationUtils?.validateName("first_name"),

  last_name: validationUtils?.validateName("last_name"),

  phone_number: validationUtils?.validatePhoneNumber(),

  email: validationUtils?.validateEmail(),

  category: Yup.string().required(validationErrors?.getRequiredField("Category")),

  ban_reason: validationUtils?.validateMessage("ban_reason"),

  address: validationUtils?.validateUnRequiredAddress("address"),

  city: validationUtils?.validateUnRequiredAddress("city"),

  state: validationUtils?.validateUnRequiredAddress("state"),

  zipcode: validationUtils?.validateUnRequiredAddress("zipcode"),

  patient_id: validationUtils?.validateUnrequiredPatientField("patient_id"),

  medical_recommendation: validationUtils?.validateUnrequiredPatientField(
    "medical_recommendation"
  ),
});

export default createPatientSchema;
